import { render } from "./TrainingLinksView.vue?vue&type=template&id=350c8f48"
import script from "./TrainingLinksView.vue?vue&type=script&lang=js"
export * from "./TrainingLinksView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__